export const demoPreSettlementsShipmentBoxes = [
    {
        "id": "57e88630-e45f-4312-881b-fe4ecf79a4c9",
        "quantity": 5000,
        "box_weight": 5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "box_format": "CAJA",
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "box_label": "TIGRE",
        "category": "CAT 1",
        "pallet": "dc6b990b-cc75-4581-934a-f17b3eb9f622",
        "lot": null,
        "season": "24-25",
        "species_id": 1,
        "exporter_id": 2,
        "producer_sag_code": "109448",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "producer_name": "Agricola Las Raices",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "780153709",
        "producer_group": "NA"
    },
    {
        "id": "57e88630-e45f-4312-881b-fe4ecf79a4c9",
        "quantity": 5000,
        "box_weight": 5,
        "variety": "SANTINA",
        "caliber": "J",
        "color": "L",
        "box_format": "CAJA",
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "box_label": "TIGRE",
        "category": "CAT 1",
        "pallet": "dc6b990b-cc75-4581-934a-f17b3eb9f622",
        "lot": null,
        "season": "24-25",
        "species_id": 1,
        "exporter_id": 2,
        "producer_sag_code": "109448",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "producer_name": "Agricola Las Raices",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "780153709",
        "producer_group": "NA"
    },
    {
        "id": "2d8dbdd7-91ed-481f-a63f-76b1d21abca6",
        "quantity": 660,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "08e130a7-7f7e-4d96-b47a-ec05f0ae4c83",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "117430",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Tres Productores S.A",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "763064689",
        "producer_group": "NA"
    },
    {
        "id": "7442dc1a-5813-43d8-92f6-0165466bfd46",
        "quantity": 770,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "09cf8506-936d-4d8c-8c29-f1987b977ed1",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "87854",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Dos Portones Agricola SpA",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "76010650K",
        "producer_group": "NA"
    },
    {
        "id": "03cf9deb-4eca-4435-b5ca-ddf1f92baa89",
        "quantity": 440,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "985aacd3-4f58-4818-b05a-d0f9bcf0a33c",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "87854",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Dos Portones Agricola SpA",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "76010650K",
        "producer_group": "NA"
    },
    {
        "id": "9216be46-874e-4fc5-8d19-f187b68431ae",
        "quantity": 620,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "d8bf1cab-e27d-40f3-a7c3-55bd01c9491f",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "87854",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Dos Portones Agricola SpA",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "76010650K",
        "producer_group": "NA"
    },
    {
        "id": "1da7d5ae-e7b8-4188-a6f5-6b0b4e424cfe",
        "quantity": 760,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "11a0cb42-3748-428d-8617-a8d37620fb65",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "87854",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Dos Portones Agricola SpA",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "76010650K",
        "producer_group": "NA"
    },
    {
        "id": "d499933c-7792-4251-b308-47672e0d9e93",
        "quantity": 590,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "0b34f950-3a83-484d-974d-effbddc9afae",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "87854",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Dos Portones Agricola SpA",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "76010650K",
        "producer_group": "NA"
    },
    {
        "id": "d23bd702-d0d0-4e52-b235-6d18133fd4c7",
        "quantity": 160,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252228",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "e1fd042f-66fd-40b9-a389-308a90869024",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "109448",
        "shipment": {
            "id": "c393ae11-041a-42c2-8521-bc70c5aaa6ca",
            "exporterRef": "60",
            "date": "2025-01-01T03:00:00.000Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "60",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "2IN1",
        "box_weight": 2.5,
        "box_type": "11121252228",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Agricola Las Raices",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "780153709",
        "producer_group": "NA"
    },
    {
        "id": "4c1fd268-41c9-44d0-87b5-7024dde7beda",
        "quantity": 360,
        "boxWeight": 2.5,
        "variety": "ROYAL DAWN",
        "caliber": "J",
        "color": "L",
        "boxType": "11121252225",
        "boxDescription": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "boxLabel": "TIGRE",
        "category": "CAT 1",
        "pallet": "2f0f7362-d93b-49fe-94de-6fa471554e6d",
        "lot": null,
        "season": "24-25",
        "speciesId": 1,
        "exporterId": 2,
        "producer_sag_code": "107351",
        "shipment": {
            "id": "44c68e38-4475-45d9-9880-48244f6c4aaf",
            "exporterRef": "12",
            "date": "2025-01-08T04:46:00.782Z",
            "ship": {
                "id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
                "etd": "2025-01-02",
                "eta": "2025-01-17",
                "transportationType": "MARITIMO"
            }
        },
        "reference_number": "12",
        "exporter_id": 2,
        "box_label": "TIGRE",
        "box_format": "CAJA",
        "box_weight": 2.5,
        "box_type": "11121252225",
        "box_description": "CEREZA/PNAT/PROCESO/MARITIMO/TIGRE (NAT)/MADERA 1000X1200 TACO/TAPA Y FONDO 2,5 KG CON MANILLA/2,5/CHERRY 2,5 KG -874/ABSORDPAD+CARTON CORRUGADO/PARRILLA CARTON C/ESQUINERO",
        "producer_name": "Las Varas de Paine Ltda",
        "ship_type": "M",
        "ship_etd": "2025-01-02",
        "ship_eta": "2025-01-17",
        "ship_trip_id": "9c17581c-f2aa-43c3-a75b-f168761e1874",
        "producer_national_id": "761630008",
        "producer_group": "NA"
    }
]

export const demoPreSettlementsMovements = [
    {
        "id": "3194d845-f826-46e6-b2e5-6a46b5b8cce6",
        "season": "24-25",
        "depositCurrency": "CLP",
        "depositAmount": 100000000,
        "equivalentCurrency": "USD",
        "equivalentAmount": 100000,
        "date": "2025-02-06T03:00:00.000Z",
        "category": null,
        "concept": "ANTICIPO",
        "description": "",
        "voucherUrl": null,
        "createdAt": "2025-02-06T15:30:06.662Z",
        "updatedAt": "2025-02-06T15:30:06.662Z",
        "deletedAt": null,
        "uploadedBy": "88d4557e-06e4-427f-a6ec-6a2fd2dab439",
        "producerId": 213,
        "speciesId": 1,
        "producer": {
            "id": 213,
            "name": "Las Varas de Paine Ltda",
            "nationalId": "761630008",
            "group": {
                "id": null,
                "name": null
            }
        },
        "species": {
            "id": 1,
            "name": "🍒 Cerezas"
        },
        "species_id": "1",
        "amount_usd": 10000,
        "producer_name": "Las Varas de Paine Ltda",
        "producer_group": "NA",
        "producer_national_id": "761630008"
    },
    {
        "id": "9c0d70b6-1d6c-4fd2-8530-fce6e32422f7",
        "season": "24-25",
        "depositCurrency": "CLP",
        "depositAmount": 1500000,
        "equivalentCurrency": "USD",
        "equivalentAmount": 1500,
        "date": "2025-02-06T03:00:00.000Z",
        "category": null,
        "concept": "ANTICIPO",
        "description": "",
        "voucherUrl": null,
        "createdAt": "2025-02-06T15:42:52.256Z",
        "updatedAt": "2025-02-06T15:42:52.256Z",
        "deletedAt": null,
        "uploadedBy": "88d4557e-06e4-427f-a6ec-6a2fd2dab439",
        "producerId": 214,
        "speciesId": 1,
        "producer": {
            "id": 214,
            "name": "Agricola Las Raices",
            "nationalId": "780153709",
            "group": {
                "id": null,
                "name": null
            }
        },
        "species": {
            "id": 1,
            "name": "🍒 Cerezas"
        },
        "species_id": "1",
        "amount_usd": 200000,
        "producer_name": "Agricola Las Raices",
        "producer_group": "NA",
        "producer_national_id": "780153709"
    }
]

export const demoPreSettlementsExistingMappings = [
    {
        "id": 1,
        "created_at": "2025-02-06T12:53:44.096339+00:00",
        "exporter_id": 2,
        "frutic_code": "11121252225",
        "cherry_box_format": "CAJA"
    },
    {
        "id": 3,
        "created_at": "2025-02-06T14:00:54.30855+00:00",
        "exporter_id": 2,
        "frutic_code": "11121252228",
        "cherry_box_format": "2IN1"
    }
]

export const demoPreSettlementsValidSettlements = [
    {
        "id": 18,
        "created_at": "2025-02-06T14:40:02.582515+00:00",
        "exporter_id": 2,
        "date_sold": "2025-01-25T11:36:25",
        "ship_trip_id": 27,
        "receiver": "RIVERKING",
        "reference_number": "60",
        "container_number": "AASSDD",
        "cost_per_kg_ex_comm_ex_tax_liq_usd": null,
        "exchange_rate": 7.3,
        "region": "CHINA",
        "total_commission_local": 8688,
        "total_freight_usd": 2000,
        "total_other_costs_local": 2000,
        "total_revenue_local": 108600,
        "total_tax_local": 9000,
        "upload_status": "approved",
        "season": "2024-2025",
        "local_currency": "RMB",
        "original_incoterm": "FOB",
        "settlement_details": [
            {
                "id": 326,
                "color": "L",
                "kilos": 980,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "NA",
                "caliber": "J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 392,
                "date_sold": "2025-01-16T14:44:02+00:00",
                "created_at": "2025-02-06T14:44:06.396426+00:00",
                "unit_weight": 2.5,
                "usd_freight": 800,
                "exchange_rate": 7.3,
                "settlement_id": 18,
                "usd_total_fob": 10317,
                "local_currency": "RMB",
                "local_total_tax": 8000,
                "local_other_costs": 1000,
                "local_total_price": 98000,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 7840
            }
        ],
        "ship_trip": {
            "id": 27,
            "eta": "2025-01-25T00:00:00+00:00",
            "etd": "2025-01-03T00:00:00+00:00",
            "ship": {
                "id": 17,
                "name": "CLIFFORD MAERSK",
                "type": "M",
                "company": "",
                "created_at": "2025-01-22T22:09:31.794827+00:00"
            },
            "ship_id": 17,
            "created_at": "2025-01-30T16:55:49.850839+00:00",
            "destination": "BRASIL"
        }
    },
    {
        "id": 2,
        "created_at": "2025-01-09T01:15:47.180469+00:00",
        "exporter_id": 2,
        "date_sold": "2024-12-20T00:00:00",
        "ship_trip_id": 24,
        "receiver": "RIVERKING",
        "reference_number": "28",
        "container_number": "MNBU4482202",
        "cost_per_kg_ex_comm_ex_tax_liq_usd": 4.66954045001202,
        "exchange_rate": 7.3,
        "region": "NANSHA",
        "total_commission_local": 71635.2,
        "total_freight_usd": 13321.4698630137,
        "total_other_costs_local": 27105,
        "total_revenue_local": 1193920,
        "total_tax_local": 98566.182,
        "upload_status": "approved",
        "season": "2024-2025",
        "local_currency": "RMB",
        "original_incoterm": "FOB",
        "settlement_details": [
            {
                "id": 36,
                "color": "D",
                "kilos": 1760,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "3J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 352,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 5,
                "usd_freight": 1285.40498678202,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 14480.9527548658,
                "local_currency": "RMB",
                "local_total_tax": 11333.3937491289,
                "local_other_costs": 2615.3947368421,
                "local_total_price": 137280,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 8236.8
            },
            {
                "id": 37,
                "color": "D",
                "kilos": 5280,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 1056,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 5,
                "usd_freight": 3856.21496034607,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 38481.4333435912,
                "local_currency": "RMB",
                "local_total_tax": 30512.9831707317,
                "local_other_costs": 7846.18421052632,
                "local_total_price": 369600,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 22176
            },
            {
                "id": 38,
                "color": "D",
                "kilos": 2640,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 528,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 5,
                "usd_freight": 1928.10748017304,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 18827.2645950451,
                "local_currency": "RMB",
                "local_total_tax": 14965.8917456446,
                "local_other_costs": 3923.09210526316,
                "local_total_price": 181280,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 10876.8
            },
            {
                "id": 39,
                "color": "L",
                "kilos": 880,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 176,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 5,
                "usd_freight": 642.702493391012,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 5586.66807043084,
                "local_currency": "RMB",
                "local_total_tax": 4504.29751567944,
                "local_other_costs": 1307.69736842105,
                "local_total_price": 54560,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3273.6
            },
            {
                "id": 40,
                "color": "D",
                "kilos": 3840,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 1536,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 2.5,
                "usd_freight": 2804.51997116078,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 23476.1106853334,
                "local_currency": "RMB",
                "local_total_tax": 19021.0804181185,
                "local_other_costs": 5706.31578947368,
                "local_total_price": 230400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 13824
            },
            {
                "id": 41,
                "color": "D",
                "kilos": 1920,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 768,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 2.5,
                "usd_freight": 1402.25998558039,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 11287.0167134843,
                "local_currency": "RMB",
                "local_total_tax": 9193.52220209059,
                "local_other_costs": 2853.15789473684,
                "local_total_price": 111360,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 6681.6
            },
            {
                "id": 42,
                "color": "L",
                "kilos": 1920,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 768,
                "date_sold": null,
                "created_at": "2025-01-09T01:15:47.180469+00:00",
                "unit_weight": 2.5,
                "usd_freight": 1402.25998558039,
                "exchange_rate": 7.3,
                "settlement_id": 2,
                "usd_total_fob": 11061.4973988932,
                "local_currency": "RMB",
                "local_total_tax": 9035.01319860627,
                "local_other_costs": 2853.15789473684,
                "local_total_price": 109440,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 6566.4
            }
        ],
        "ship_trip": {
            "id": 24,
            "eta": "2024-12-31T00:00:00+00:00",
            "etd": "2024-12-16T00:00:00+00:00",
            "ship": {
                "id": 17,
                "name": "CLIFFORD MAERSK",
                "type": "M",
                "company": "",
                "created_at": "2025-01-22T22:09:31.794827+00:00"
            },
            "ship_id": 17,
            "created_at": "2025-01-22T22:10:46.484042+00:00",
            "destination": "CHINA"
        }
    },
    {
        "id": 14,
        "created_at": "2025-01-22T22:15:14.152956+00:00",
        "exporter_id": 2,
        "date_sold": "2024-12-30T00:00:00",
        "ship_trip_id": 25,
        "receiver": "RIVERKING",
        "reference_number": "91",
        "container_number": "SEKU9172827",
        "cost_per_kg_ex_comm_ex_tax_liq_usd": 3.55936629739105,
        "exchange_rate": 7.31,
        "region": "CNSHA",
        "total_commission_local": 59807.4,
        "total_freight_usd": 10876.7414500684,
        "total_other_costs_local": 13743,
        "total_revenue_local": 996790,
        "total_tax_local": 83091.564,
        "upload_status": "approved",
        "season": "2024-2025",
        "local_currency": "RMB",
        "original_incoterm": "FOB",
        "settlement_details": [
            {
                "id": 215,
                "color": "D",
                "kilos": 6160,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "3J",
                "variety": "LAPINS",
                "incoterm": "FOB",
                "quantity": 1232,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 5,
                "usd_freight": 3738.87987346101,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 43838.701689474,
                "local_currency": "RMB",
                "local_total_tax": 34303.1225249451,
                "local_other_costs": 4724.15625,
                "local_total_price": 411510,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 24690.6
            },
            {
                "id": 216,
                "color": "D",
                "kilos": 5280,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "LAPINS",
                "incoterm": "FOB",
                "quantity": 1056,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 5,
                "usd_freight": 3204.7541772523,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 30066.3181981518,
                "local_currency": "RMB",
                "local_total_tax": 24060.7841500818,
                "local_other_costs": 4049.27678571429,
                "local_total_price": 288640,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 17318.4
            },
            {
                "id": 217,
                "color": "D",
                "kilos": 1760,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "3J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 352,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 5,
                "usd_freight": 1068.25139241743,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 9884.60602943191,
                "local_currency": "RMB",
                "local_total_tax": 7922.45331770985,
                "local_other_costs": 1349.75892857143,
                "local_total_price": 95040,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 5702.4
            },
            {
                "id": 218,
                "color": "D",
                "kilos": 880,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 176,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 5,
                "usd_freight": 534.125696208716,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 4323.55284993187,
                "local_currency": "RMB",
                "local_total_tax": 3521.0903634266,
                "local_other_costs": 674.879464285714,
                "local_total_price": 42240,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2534.4
            },
            {
                "id": 219,
                "color": "D",
                "kilos": 2880,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "LAPINS",
                "incoterm": "FOB",
                "quantity": 1152,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 2.5,
                "usd_freight": 1748.04773304671,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 12574.8089075994,
                "local_currency": "RMB",
                "local_total_tax": 10403.2215283059,
                "local_other_costs": 2208.69642857143,
                "local_total_price": 124800,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 7488
            },
            {
                "id": 220,
                "color": "D",
                "kilos": 960,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "ROYAL DAWN",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2024-12-30T00:00:00+00:00",
                "created_at": "2025-01-22T22:15:14.152956+00:00",
                "unit_weight": 2.5,
                "usd_freight": 582.682577682236,
                "exchange_rate": 7.31,
                "settlement_id": 14,
                "usd_total_fob": 3366.60274948767,
                "local_currency": "RMB",
                "local_total_tax": 2880.89211553085,
                "local_other_costs": 736.232142857143,
                "local_total_price": 34560,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2073.6
            }
        ],
        "ship_trip": {
            "id": 25,
            "eta": "2025-02-22T00:00:00+00:00",
            "etd": "2025-01-22T00:00:00+00:00",
            "ship": {
                "id": 18,
                "name": "YM ENLIGHTENMENT",
                "type": "M",
                "company": null,
                "created_at": "2025-01-22T22:14:06.874825+00:00"
            },
            "ship_id": 18,
            "created_at": "2025-01-22T22:14:25.297446+00:00",
            "destination": null
        }
    },
    {
        "id": 13,
        "created_at": "2025-01-22T22:14:34.390932+00:00",
        "exporter_id": 2,
        "date_sold": "2024-12-31T00:00:00",
        "ship_trip_id": 25,
        "receiver": "RIVERKING",
        "reference_number": "86",
        "container_number": "FBIU5119222",
        "cost_per_kg_ex_comm_ex_tax_liq_usd": 3.69847165222678,
        "exchange_rate": 7.31,
        "region": "CNSHA",
        "total_commission_local": 66453.9,
        "total_freight_usd": 10876.7414500684,
        "total_other_costs_local": 17820,
        "total_revenue_local": 1107565,
        "total_tax_local": 92096.199,
        "upload_status": "approved",
        "season": "2024-2025",
        "local_currency": "RMB",
        "original_incoterm": "FOB",
        "settlement_details": [
            {
                "id": 212,
                "color": "D",
                "kilos": 4400,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "3J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 880,
                "date_sold": "2024-12-31T00:00:00+00:00",
                "created_at": "2025-01-22T22:14:34.390932+00:00",
                "unit_weight": 5,
                "usd_freight": 2658.75902112783,
                "exchange_rate": 7.31,
                "settlement_id": 13,
                "usd_total_fob": 35942.3333252818,
                "local_currency": "RMB",
                "local_total_tax": 27806.0149477457,
                "local_other_costs": 4356,
                "local_total_price": 334400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 20064
            },
            {
                "id": 213,
                "color": "D",
                "kilos": 8800,
                "label": "TIGRE",
                "format": "2IN1",
                "pallet": "N/A",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 1760,
                "date_sold": "2024-12-31T00:00:00+00:00",
                "created_at": "2025-01-22T22:14:34.390932+00:00",
                "unit_weight": 5,
                "usd_freight": 5317.51804225566,
                "exchange_rate": 7.31,
                "settlement_id": 13,
                "usd_total_fob": 55999.5713600289,
                "local_currency": "RMB",
                "local_total_tax": 44343.2764692998,
                "local_other_costs": 8712,
                "local_total_price": 533280,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 31996.8
            },
            {
                "id": 214,
                "color": "D",
                "kilos": 4800,
                "label": "TIGRE",
                "format": "CAJA",
                "pallet": "N/A",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 1920,
                "date_sold": "2024-12-31T00:00:00+00:00",
                "created_at": "2025-01-22T22:14:34.390932+00:00",
                "unit_weight": 2.5,
                "usd_freight": 2900.46438668491,
                "exchange_rate": 7.31,
                "settlement_id": 13,
                "usd_total_fob": 24567.797229874,
                "local_currency": "RMB",
                "local_total_tax": 19946.9075829545,
                "local_other_costs": 4752,
                "local_total_price": 239885,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 14393.1
            }
        ],
        "ship_trip": {
            "id": 25,
            "eta": "2025-02-22T00:00:00+00:00",
            "etd": "2025-01-22T00:00:00+00:00",
            "ship": {
                "id": 18,
                "name": "YM ENLIGHTENMENT",
                "type": "M",
                "company": null,
                "created_at": "2025-01-22T22:14:06.874825+00:00"
            },
            "ship_id": 18,
            "created_at": "2025-01-22T22:14:25.297446+00:00",
            "destination": null
        }
    },
    {
        "id": 15,
        "created_at": "2025-01-23T22:07:16.713975+00:00",
        "exporter_id": 2,
        "date_sold": "2025-01-09T00:00:00",
        "ship_trip_id": 26,
        "receiver": "QUPAI",
        "reference_number": "SA1618CZ",
        "container_number": "MNBU4406136",
        "cost_per_kg_ex_comm_ex_tax_liq_usd": 4.64913311827445,
        "exchange_rate": 7.3507,
        "region": "NANSHA",
        "total_commission_local": 62587.92,
        "total_freight_usd": 13290.9287550845,
        "total_other_costs_local": 33532,
        "total_revenue_local": 782349,
        "total_tax_local": 63830.64,
        "upload_status": "approved",
        "season": "2024-2025",
        "local_currency": "USD",
        "original_incoterm": "FOB",
        "settlement_details": [
            {
                "id": 249,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011542",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-09T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            },
            {
                "id": 248,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011509",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3837.61035301147,
                "local_currency": "USD",
                "local_total_tax": 3383.63607811859,
                "local_other_costs": 1676.6,
                "local_total_price": 41472,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3317.76
            },
            {
                "id": 255,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200014172",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-09T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            },
            {
                "id": 251,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011580",
                "caliber": "3J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-09T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 4363.19300986927,
                "local_currency": "USD",
                "local_total_tax": 3759.59564235399,
                "local_other_costs": 1676.6,
                "local_total_price": 46080,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3686.4
            },
            {
                "id": 256,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002025",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 254,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200014121",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            },
            {
                "id": 261,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002825",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            },
            {
                "id": 244,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011414",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3837.61035301147,
                "local_currency": "USD",
                "local_total_tax": 3383.63607811859,
                "local_other_costs": 1676.6,
                "local_total_price": 41472,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3317.76
            },
            {
                "id": 242,
                "color": "L",
                "kilos": 262.5,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011413",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 105,
                "date_sold": "2025-01-09T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 181.711916573422,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 953.537242411871,
                "local_currency": "USD",
                "local_total_tax": 856.678694546807,
                "local_other_costs": 458.4453125,
                "local_total_price": 10500,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 840
            },
            {
                "id": 246,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011448",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 247,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011451",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 243,
                "color": "L",
                "kilos": 697.5,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011413",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 279,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 482.834521180806,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 2374.57273555972,
                "local_currency": "USD",
                "local_total_tax": 2162.50179037744,
                "local_other_costs": 1218.1546875,
                "local_total_price": 26505,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2120.4
            },
            {
                "id": 245,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011446",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 4144.20023617852,
                "local_currency": "USD",
                "local_total_tax": 3602.94582392257,
                "local_other_costs": 1676.6,
                "local_total_price": 44160,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3532.8
            },
            {
                "id": 250,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011553",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 253,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200014101",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 252,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2200011594",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-05T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            },
            {
                "id": 259,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002316",
                "caliber": "3J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 4363.19300986927,
                "local_currency": "USD",
                "local_total_tax": 3759.59564235399,
                "local_other_costs": 1676.6,
                "local_total_price": 46080,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3686.4
            },
            {
                "id": 257,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002032",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-07T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 260,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002734",
                "caliber": "J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3268.22914141552,
                "local_currency": "USD",
                "local_total_tax": 2976.34655019691,
                "local_other_costs": 1676.6,
                "local_total_price": 36480,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 2918.4
            },
            {
                "id": 262,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002827",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-05T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3706.21468879702,
                "local_currency": "USD",
                "local_total_tax": 3289.64618705974,
                "local_other_costs": 1676.6,
                "local_total_price": 40320,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3225.6
            },
            {
                "id": 258,
                "color": "L",
                "kilos": 960,
                "label": "GOLD FISH",
                "format": "CAJA",
                "pallet": "2300002044",
                "caliber": "2J",
                "variety": "SANTINA",
                "incoterm": "FOB",
                "quantity": 384,
                "date_sold": "2025-01-10T00:00:00+00:00",
                "created_at": "2025-01-23T22:07:16.713975+00:00",
                "unit_weight": 2.5,
                "usd_freight": 664.546437754228,
                "exchange_rate": 7.3507,
                "settlement_id": 15,
                "usd_total_fob": 3487.22191510627,
                "local_currency": "USD",
                "local_total_tax": 3132.99636862832,
                "local_other_costs": 1676.6,
                "local_total_price": 38400,
                "quartil_vs_market": null,
                "difference_vs_market": null,
                "local_total_commision": 3072
            }
        ],
        "ship_trip": {
            "id": 26,
            "eta": "2025-01-23T00:00:00+00:00",
            "etd": "2025-01-15T00:00:00+00:00",
            "ship": {
                "id": 19,
                "name": "MAERSK SAN CRISTOBAL",
                "type": "M",
                "company": null,
                "created_at": "2025-01-23T21:29:01.507583+00:00"
            },
            "ship_id": 19,
            "created_at": "2025-01-23T21:29:21.965153+00:00",
            "destination": null
        }
    }
]

export const demoUniqueShipments = [
    {
        "reference_number": "5",
        "ship_name": "NAVE1",
        "ship_etd": "2025-01-02",
        "hasSettlement": true
    },
    {
        "reference_number": "12",
        "ship_name": "NAVE1",
        "ship_etd": "2025-01-02",
        "hasSettlement": false
    },
    {
        "reference_number": "16",
        "ship_name": "NAVE2",
        "ship_etd": "2025-02-15",
        "hasSettlement": false
    },
    {
        "reference_number": "18",
        "ship_name": "NAVE2",
        "ship_etd": "2025-02-15",
        "hasSettlement": false
    }
]

